import { requester } from '../utils';

export const fetchAllUsers = query => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/user?${query}`,
        method: 'GET',
        withAuth: true,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        console.log('fetch users error', err);
        reject(err);
      });
  });
};
export const fetchSearchedUsers = query => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/user/panel/activated?${query}`,
        method: 'GET',
        withAuth: true,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        console.log('fetch users error', err);
        reject(err);
      });
  });
};

export const assignUserToCafe = ({ cafeId, userId, roleId }) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/cafe/user`,
        method: 'POST',
        data: {
          cafeId,
          userId,
          roleId,
        },
        withAuth: true,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        console.log('fetch users error', err);
        reject(err);
      });
  });
};

export const fetchUser = id => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/user/${id}`,
        method: 'GET',
        withAuth: true,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        console.log('fetch users error', err);
        reject(err);
      });
  });
};

export const fetchAllCafeUsers = cafeId => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/user/cafe/${cafeId}`,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const createNewUser = userObject => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/user`,
        method: 'POST',
        data: userObject,
        withAuth: true,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const updateUser = userObject => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/user`,
        method: 'PUT',
        data: userObject,
        withAuth: true,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};
